import { render, staticRenderFns } from "./AssetMaster.vue?vue&type=template&id=4ce0c10e"
import script from "./AssetMaster.vue?vue&type=script&lang=js"
export * from "./AssetMaster.vue?vue&type=script&lang=js"
import style0 from "./AssetMaster.vue?vue&type=style&index=0&id=4ce0c10e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports